import { useEffect, useRef } from "react";

function useOutsideClick(callback, ignoreRefs = []) {
  const ref = useRef();

  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        const isIgnored =
          Array.isArray(ignoreRefs) &&
          ignoreRefs.some(
            (ignoreRef) =>
              ignoreRef &&
              ignoreRef.current &&
              ignoreRef.current.contains(event.target)
          );
        if (!isIgnored) {
          callback();
        }
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [callback, ignoreRefs]);

  return ref;
}

export default useOutsideClick;
